import { useState } from "react";
import { fetchProductsHistoryReportCsv } from "../api/fetchProductsHistoryReport/fetchProductsHistoryReportCsvApi";
import { FetchProductsHistoryReportParams } from "../api/fetchProductsHistoryReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadProductsHistoryReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchProductsHistoryReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchProductsHistoryReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `products-history-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
